module.exports = __webpack_public_path__ + "static/media/idci.fdec3a56.png";